import {
  Box,
  Circle,
  Divider,
  Flex,
  Heading,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  Stack,
  Table,
  Button,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import profile from "../../../Assets/newProfile.svg";
import message from "../../../Assets/message2.svg";

import * as api from "../../../services/api";
import Swal from "sweetalert2";
import { notification, socket } from "socket";
import { Login, sendNotification } from "helper/notification";
import { defaultMessageByType } from "helper/defaultMessage";

const Applications_page = ({ applicationData, title }) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState({
    name: "",
    jobTitle: "",
    image: "",
    isOpen: false,
    id: "",
  });
  const [data, setData] = useState([]);
  const [text, setText] = useState("");
  const [error, setError] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (applicationData?.length) {
      setData(applicationData);
    }
  }, [applicationData?.length]);


  const sendMessage = async () => {
    try {
      const res = await api.addNewUser({
        userId: user._id,
        name: modalOpen.name,
        image: modalOpen.image,
        jobTitle: modalOpen.jobTitle,
        consumerId: modalOpen.id,
      });
      setModalOpen({
        name: "",
        value: "",
        image: "",
        isOpen: false,
        id: "",
      });
      const name = user.name + "_" + "recruiter";
      const room = modalOpen.id + "_" + user?._id;
      const chat = {
        message: text,
        room: room,
        username: user.name + "_" + "recruiter",
        timestamp: new Date(),
      };

      socket.emit("login", { name, room }, (err) => {
        socket.emit("message", chat);
        if (err) {
          return;
        } else {
        }
      });

      Swal.fire({
        title: "Success",
        text: "Message sent successfully",
        icon: "success",
        timer: 1500,
      });
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  return (
    <Box>
      {data?.length === 0 ? (
        <p>No applications yet</p>
      ) : (
        <>
          {/* Desktop View */}

          <Modal
            size={["sm", "sm", "lg", "lg"]}
            isCentered={true}
            isOpen={modalOpen.isOpen}
            onClose={() =>
              setModalOpen({
                name: "",
                image: "",
                jobTitle: "",
                isOpen: false,
                id: "",
              })
            }
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                <Text fontSize={32} fontWeight={600} fontFamily={"Epilogue"}>
                  Send a message
                </Text>
                <Text fontSize={16} fontWeight={500} fontFamily={"Epilogue"}>
                  Write message to candidate
                </Text>
              </ModalHeader>
              <ModalCloseButton zIndex={99} />
              <ModalBody>
                <Flex align="center" gap={5} mb={5}>
                  <Textarea
                    placeholder="Write a message"
                    fontFamily={"Roboto"}
                    w={"100%"}
                    h={"200px"}
                    resize={"unset"}
                    bg={"linear-gradient(0deg, #F4F4F4, #F4F4F4)"}
                    onChange={(e) => setText(e.target.value)}
                  />
                </Flex>
                {error && <Text color={"red.600"}>Write a message</Text>}
                <Flex justifyContent={"end"} gap={2}>
                  {/* <button
                    className="btn-primary-custom"
                    onClick={() => sendMessage()}
                  >
                    send
                  </button> */}
                  <Button
                    color={"#FFFFFF"}
                    fontSize={16}
                    w={28}
                    fontFamily={"Roboto"}
                    fontWeight={450}
                    bg={"#6C56FB"}
                    borderRadius={12}
                    _hover={{ background: "#6C56FB" }}
                    onClick={
                      text !== ""
                        ? () => sendMessage()
                        : () => {
                            setError(true);
                          }
                    }
                  >
                    Send
                  </Button>
                  <Button
                    fontSize={16}
                    w={28}
                    fontFamily={"Roboto"}
                    fontWeight={450}
                    borderRadius={12}
                    onClick={() =>
                      setModalOpen({
                        isOpen: false,
                      })
                    }
                  >
                    Discard
                  </Button>
                </Flex>
              </ModalBody>
            </ModalContent>
          </Modal>
          {/* Desktop View */}
          <Box display={["none", "none", "block", "block"]}>
            <TableContainer>
              <Table>
                <Tbody>
                  {/* Candidate Row */}
                  {data?.map((item, idx) => (
                    <Tr key={idx}>
                      <Td>
                        <Flex align="center" gap={5}>
                          {/* Picture */}
                          <Circle
                            size={12}
                            cursor="pointer"
                            overflow="hidden"
                            border="1px solid #D9D9D9"
                            onClick={() => {
                              navigate(
                                `/hiring/recruiter/studentprofile/${item.appliedBy._id}`
                              );
                            }}
                          >
                            {item.appliedBy?.profile_photo ? (
                              <img
                                style={{ height: "100%", width: "100%" }}
                                src={item.appliedBy?.profile_photo}
                                alt="student"
                              />
                            ) : (
                              <img
                                style={{ height: "100%", width: "100%" }}
                                src={profile}
                                alt="student"
                              />
                            )}
                          </Circle>
                          {/* name */}
                          <Text
                            fontSize={20}
                            fontFamily={"Roboto"}
                            fontWeight={500}
                            cursor="pointer"
                            onClick={() => {
                              navigate(
                                `/hiring/recruiter/studentprofile/${item.appliedBy?._id}`
                              );
                            }}
                          >
                            {item.appliedBy?.name}
                          </Text>
                        </Flex>
                      </Td>
                      {/* <Td>
                  <Text>#{item.rank}</Text>
                </Td> */}
                      {/* Job Role */}
                      {/* <Td textAlign="center">
                        <Text fontFamily={"Roboto"} fontWeight={500}>
                          3D Environment Creator
                        </Text>
                      </Td> */}
                      <Td>
                        <Text>
                          {moment(item.createdAt).format("DD-MM-YYYY")}
                        </Text>
                      </Td>
                      {/* status */}
                      <Td>
                        <Stack
                          css={{
                            "@media (max-width: 1980px)": {
                              width: 110,
                            },
                            "@media (max-width: 1540px)": {
                              width: 110,
                            },
                          }}
                        >
                          <Select
                            variant="outline"
                            borderRadius={40}
                            fontFamily={"Roboto"}
                            bg={
                              (item.status === "inTouch" &&
                                "rgba(255, 206, 1, 0.14)") ||
                              (item.status === "hired" &&
                                "rgba(0, 212, 174, 0.14)") ||
                              (item.status === "rejected" &&
                                "rgba(255, 89, 94, 0.14)") ||
                              (item.status === "applied" &&
                                "rgba(255, 206, 1, 0.14);")
                            }
                            value={item.status}
                            onChange={async (e) => {
                              setData((state) => {
                                const idx = state.findIndex(
                                  (val) => val._id === item._id
                                );
                                const filteredItem = state[idx];
                                filteredItem.status = e.target.value;
                                const before = state.slice(0, idx);
                                const after = state.slice(idx + 1);

                                return [...before, filteredItem, ...after];
                              });
                              const room = item.appliedBy._id;
                              await api.acceptOrRejectApplication(
                                item._id,
                                e.target.value,
                                item.hiringPostId?._id
                              );
                              Login({
                                room: room,
                                name: item.appliedBy?.name,
                              });
                              sendNotification({
                                room: room,
                                username: item.appliedBy?.name,
                                message: defaultMessageByType(
                                  e.target.value,
                                  item.hiringPostId.jobRoleTitle
                                ),
                              });
                            }}
                          >
                            {/* <option>{`${item.status[0].toUpperCase()}${item.status.slice(
                        1
                      )}`}</option> */}
                            <option value="applied">Applied</option>
                            <option value="inTouch">In touch</option>
                            <option value="hired">Hired</option>
                            <option value="rejected" background="red">
                              Reject
                            </option>
                          </Select>
                        </Stack>
                      </Td>
                      {/* Menu */}
                      <Td>
                        <Popover>
                          <PopoverTrigger>
                            <Circle
                              size={8}
                              border="1px solid"
                              _hover={{ background: "#D9D9D9" }}
                            >
                              <img
                                height="70%"
                                width="70%"
                                src="https://cdn-icons-png.flaticon.com/512/2311/2311524.png"
                                alt="Profile_Pic"
                              />
                            </Circle>
                          </PopoverTrigger>
                          <PopoverContent
                            w={200}
                            bg="#FFFFFF"
                            borderRadius={10}
                          >
                            <PopoverArrow bg="#FFFFFF" />
                            <PopoverCloseButton />
                            <PopoverBody>
                              <Flex flexDirection="column" my={5} gap={2}>
                                {/* Send Message */}
                                <Flex
                                  align="center"
                                  gap={2}
                                  cursor="pointer"
                                  onClick={() => {
                                    setModalOpen({
                                      name: item.appliedBy?.name,
                                      isOpen: true,
                                      jobTitle: item?.jobTitle,
                                      image: item.appliedBy?.profile_photo,
                                      id: item.appliedBy?._id,
                                    });
                                  }}
                                >
                                  <Circle
                                    size={7}
                                    p={1}
                                    // border={"1px solid #E7E6E8"}
                                  >
                                    <img src={message} alt="msg" />
                                  </Circle>
                                  <Box>
                                    {/* Route to respective page */}
                                    <Text fontSize={18} fontWeight={400}>
                                      Send Message
                                    </Text>
                                  </Box>
                                </Flex>
                                <Divider border="1px solid #DEDEDE" />
                                {/* View Profile */}
                                <Flex align="center" gap={2} cursor="pointer">
                                  <Circle size={7} border={"1px solid #E7E6E8"}>
                                    <img src={profile} alt="profile icon" />
                                  </Circle>

                                  <Box
                                    onClick={() => {
                                      navigate(
                                        `/hiring/recruiter/studentprofile/${item.appliedBy?._id}`
                                      );
                                    }}
                                  >
                                    <Text
                                      fontSize={18}
                                      fontFamily={"Roboto"}
                                      fontWeight={400}
                                    >
                                      View Profile
                                    </Text>
                                  </Box>
                                </Flex>
                              </Flex>
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>

          {/* Mobile View */}
          <Box display={["block", "block", "none", "none"]}>
            {/* <Text
              align="start"
              fontSize={20}
              fontWeight={600}
              color={"#544D5E"}
            >{`Total Applications ${data?.length}`}</Text> */}
            {data?.map((item, idx) => (
              <Box key={idx} borderBottom={"1px solid #E7E6E8;"} px={2} py={6}>
                <Flex align={"center"} justify={"space-between"}>
                  <Flex gap={2} align={"center"}>
                    {/* profile */}
                    <Circle
                      size={12}
                      border={"1px solid"}
                      overflow="hidden"
                      onClick={() => {
                        navigate(
                          `/hiring/recruiter/studentprofile/${item.appliedBy?._id}`
                        );
                      }}
                    >
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={item.appliedBy?.profile_photo}
                        alt="img"
                      />
                    </Circle>
                    {/* name and date */}
                    <Flex flexDir={"column"}>
                      <Text
                        fontSize={16}
                        fontFamily={"Roboto"}
                        fontWeight={500}
                        textAlign={"left"}
                      >
                        {item.appliedBy?.name}
                      </Text>
                      {/* date */}

                      <Text
                        fontSize={14}
                        color={"#9D99A3"}
                        align={"start"}
                        textAlign={"left"}
                      >
                        {moment(item.createdAt).format("DD-MM-YYYY")}
                      </Text>
                    </Flex>
                  </Flex>
                  {/* status */}
                  <Stack>
                    <Select
                      variant="outline"
                      borderRadius={40}
                      textAlign="center"
                      bg={
                        (item.status == "applied" &&
                          "rgba(255, 206, 1, 0.14)") ||
                        (item.status == "inTouch" &&
                          "rgba(255, 206, 1, 0.14)") ||
                        (item.status == "hired" && "rgba(0, 212, 174, 0.14)") ||
                        (item.status == "rejected" && "rgba(255, 89, 94, 0.14)")
                      }
                      value={item.status}
                      fontSize={14}
                      fontFamily={"Roboto"}
                      onChange={async (e) => {
                        setData((state) => {
                          const idx = state.findIndex(
                            (val) => val._id === item._id
                          );
                          const filteredItem = state[idx];
                          filteredItem.status = e.target.value;
                          const before = state.slice(0, idx);
                          const after = state.slice(idx + 1);

                          return [...before, filteredItem, ...after];
                        });

                        await api.acceptOrRejectApplication(
                          item._id,
                          e.target.value,
                          item.hiringPostId?._id
                        );
                      }}
                    >
                      {/* <option>{`${item.status[0].toUpperCase()}${item.status.slice(
                        1
                      )}`}</option> */}
                      <option value="applied">Applied</option>
                      <option value="inTouch">In touch</option>
                      <option value="hired">Hired</option>
                      <option value="rejected" background="red">
                        Reject
                      </option>
                    </Select>
                  </Stack>
                </Flex>
              </Box>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default Applications_page;
